<template>
  <div class="contact-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner">
      <div class="content">
        <h1>产业咨询</h1>
        <p>对地方政府、园区及企业提供超长期国债、专项债、中央预算内投资、专项资金及大型项目的前期研究和决策以及项目实施和运行（或称运营）的全生命周期工程咨询服务。</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary">了解详情</el-button>
          <el-button class="btn-dark" type="primary">&gt;</el-button>
        </div>
      </div>
    </div>

    <!-- 服务卡片部分 -->
    <div class="service-cards">
      <!-- 卡片1 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/contact-bg2.png" alt="可落地的成本-收益精算模型">
        </div>
        <div class="card-content">
          <h2>可落地的成本-收益精算模型</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>数据的动态分析，是公司保持竞争力的核心要素之一。我们的专业团队拥有丰富的经验，能够精准地分析企业（尤其是大型企业）成本数据流，并从中挖掘价值。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>为您全方位提供符合市场规律的成本数据分析服务，涵盖从产品定价到资源配置的整个链条，确保您能做出最优的商业决策。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片2 -->
      <div class="service-card">
        <div class="card-content">
          <h2>组织适配度预检机制</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>每个组织都有其独特的结构和文化特点，这直接影响着管理效率。我们帮助客户深入分析组织适配性，确保管理系统与组织特性相匹配。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过先进的组织健康度评估和风险预警系统，我们为客户提供全面的组织诊断，识别潜在问题并提供解决方案，确保组织能够高效、和谐地运作。</p>
            </div>
          </div>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/contact-bg3.png" alt="组织适配度预检机制">
        </div>
      </div>

      <!-- 卡片3 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/contact-bg4.png" alt="竞争生态位诊断矩阵">
        </div>
        <div class="card-content">
          <h2>竞争生态位诊断矩阵</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>在复杂多变的市场环境中，精准定位企业竞争生态位是制胜的关键。我们开发了独特的诊断矩阵，帮助客户全面评估市场格局。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>基于大数据分析和竞争情报，我们能够精确识别市场机会与威胁，为客户提供战略性指导，帮助其在激烈的市场竞争中赢得优势。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片4 -->
      <div class="service-card">
        <div class="card-content">
          <h2>政策合规推演沙盘</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>政策法规环境日趋复杂，准确理解和预测政策走向对企业经营至关重要。我们提供前瞻性的政策分析和情景模拟，帮助客户做好政策应对准备。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过我们专业的政策合规推演沙盘系统，客户能够清晰看到政策变化对业务的潜在影响，并提前制定应对策略，降低合规风险。</p>
            </div>
          </div>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/contact-bg5.png" alt="政策合规推演沙盘">
        </div>
      </div>
    </div>

    <!-- 服务咨询部分 -->
    <div class="section-contact">
      <div class="contact-content">
        <h2>开启专属服务<br>获取更大价值</h2>
        <el-form class="contact-form" :model="contactForm" :rules="contactRules" ref="contactForm">
          <el-input v-model="contactForm.name" placeholder="您的姓名"></el-input>
          <el-input v-model="contactForm.mobile" placeholder="手机号码"></el-input>
          <div class="actions">
            <el-button class="btn-yellow" type="primary" @click="submitContactForm">Services</el-button>
            <el-button class="btn-dark" type="primary">&gt;</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { saveUserRequirementApi } from '@/api/index';

export default {
  name: 'contactPage',
  data() {
    return {
      contactForm: {
        name: '',
        mobile: '',
        companyName: '测试公司名称',
        demandType: '2' // 产业咨询服务类型
      },
      contactRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitContactForm() {
      // 判断姓名和手机号是否为空
      if (!this.contactForm.name || this.contactForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      if (!this.contactForm.mobile || this.contactForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          saveUserRequirementApi(this.contactForm).then(res => {
            this.$message.success('提交成功');
            this.contactForm.name = '';
            this.contactForm.mobile = '';
          }).catch(err => {
            this.$message.error('提交失败，请稍后重试');
            console.error(err);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.contact-page {
  width: 100%;
  background-color: #fff;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 1080px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/contact-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  color: #fff;

  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 345px;

    h1 {
      font-weight: bold;
      font-size: 78px;
      line-height: 92px;
      margin-bottom: 30px;
    }

    p {
      font-size: 17px;
      font-weight: bold;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      line-height: 25px;
      margin-bottom: 70px;
      max-width: 700px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #0F0FB1;
        width: 150px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }
      
      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }
}

// 服务卡片区域
.service-cards {
  width: 1200px;
  margin: 80px auto;
}

.service-card {
  display: flex;
  justify-content: space-between;
  margin-bottom: 80px;

  .card-image {
    width: 45%;
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .card-content {
    width: 45%;
    padding: 20px 0;

    h2 {
      font-weight: bold;
      font-size: 32px;
      color: #19456B;
      line-height: 42px;
      margin-bottom: 30px;
    }

    .feature {
      display: flex;
      margin-bottom: 20px;

      .feature-icon {
        color: #4CAF50;
        font-size: 20px;
        margin-right: 10px;
        margin-top: 2px;
      }

      .feature-text {
        p {
          font-size: 17px;
          color: #382933;
          line-height: 25px;
          margin: 0;
        }
      }
    }
  }
}

// 服务咨询部分
.section-contact {
  margin: 0 auto 100px;
  width: 1200px;
  height: 340px;
  box-sizing: border-box;
  padding: 40px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/bg-contact.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .contact-content {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h2 {
      font-weight: bold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 52px;
    }

    .contact-form {
      display: block;

      .el-input {
        width: 350px;
        display: block;
        margin-bottom: 25px;

        ::v-deep .el-input__inner {
          background-color: transparent;
          border: none;
          border-bottom: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 0;
          padding-left: 0;
          height: 50px;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 24px;

          &:focus {
            border-bottom-color: #fff;
          }

          &::placeholder {
            color: #ccc;
            font-size: 24px;
          }
        }
      }

      .actions {
        display: flex;

        .btn-yellow {
          background-color: #ffc107;
          border-color: #ffc107;
          color: #0F0FB1;
          width: 150px;
          height: 50px;
          font-size: 20px;
          font-weight: bold;
          line-height: 22px;
        }

        .btn-dark {
          background-color: #002366;
          border-color: #002366;
          color: #fff;
          width: 50px;
          height: 50px;
          margin-left: -5px;
        }
      }
    }
  }
}
</style>